import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { isNumeric } from '../../helpers/isNumeric';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { Base } from '../Base';
import { badgeStyles } from './Badge.styles';
import { badgeTheme } from './Badge.stylex';
export const Badge = createPolymorphicComponent(forwardRef(function Badge(props, forwardedRef) {
    const { styles, sx, value, maxValue, showZero, dot, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'Badge',
        styles: [badgeStyles, styles],
    });
    const valueAsNumber = isNumeric(value) ? Number(value) : undefined;
    const invisible = (value === undefined && !dot) ||
        (valueAsNumber !== undefined && valueAsNumber <= 0 && !showZero);
    const displayValue = useMemo(() => dot
        ? null
        : valueAsNumber !== undefined
            ? maxValue !== undefined && valueAsNumber > maxValue
                ? `${maxValue}+`
                : Math.max(0, valueAsNumber)
            : value, [dot, value, maxValue, valueAsNumber]);
    return (_jsxs(Base, { ...other, sx: [
            badgeTheme,
            globalStyles,
            combineStyles('host', invisible && 'host$invisible', dot && 'host$dot'),
            sx,
        ], ref: forwardedRef, children: [_jsx("div", { ...getStyles('background') }), _jsx("div", { ...getStyles('label'), children: displayValue })] }));
}));
